export const vipdetail = { 0: '普通用户', 1: '视频会员', 2: '商城会员' };
